import React from 'react'
import styles from './SelectPillButton.module.css'

type SelectPillButtonProps = {
    label: string
    selected: boolean
    onClick: () => void
    dataClickLabel?: string
}

// DEV-3061 縦型EF step1用の選択ピルボタン
export const SelectPillButton = ({
    label,
    selected,
    onClick,
    dataClickLabel,
}: SelectPillButtonProps) => {
    return (
        <button
            type='button'
            className={`${styles.button} ${selected ? styles.selected : ''}`}
            onClick={onClick}
            data-click-label={dataClickLabel}
        >
            <span className={styles.circle}>
                <span className={styles.check}>✓</span>
            </span>
            <span className={styles.label}>{label}</span>
        </button>
    )
}

export default SelectPillButton
